<template>
  <div class="custom-select-wrapper">
    <!-- Отображение выбранного статуса -->
    <div
      class="custom-select"
      @click="toggleSelect"
      :style="{ background: getStatusColor(order.status) }"
    >
      <span class="title_status">{{ getStatusName(order.status) }}</span>
      <span class="arrow" :class="{ open: selectOpen }"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 100 100" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M50 60.671 24.414 35.086a2 2 0 1 0-2.828 2.828l27 27a2 2 0 0 0 2.828 0l27-27c.391-.39.586-.902.586-1.414s-.195-1.024-.586-1.414a2 2 0 0 0-2.828 0z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg></span>
    </div>
    <!-- Выпадающий список с вариантами -->
    <ul v-if="selectOpen" class="custom-select-options">
      <li
        v-for="status in statuses"
        :key="status.code"
        @click.stop="selectStatus(status.code)"
        :style="{ background: status.color }"
      >
        {{ status.name }}
      </li>
    </ul>
  </div>
</template>

<script>import { ORDERS_API_BASE } from '@/config/api';

export default {
  name: "CustomSelect",
  props: {
    order: {
      type: Object,
      required: true
    },
    statuses: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectOpen: false
    };
  },
  methods: {
    toggleSelect() {
      this.selectOpen = !this.selectOpen;
    },
    selectStatus(code) {
      this.$emit("update:orderStatus", code); // обновляем локально
      this.selectOpen = false;

      // Отправляем обновление на сервер
      this.updateOrderStatus(code);
    },
    getStatusName(code) {
      const status = this.statuses.find((s) => s.code === code);
      return status ? status.name : code;
    },
    getStatusColor(code) {
      const status = this.statuses.find((s) => s.code === code);
      return status ? status.color : "#fff";
    },
    async updateOrderStatus(newStatus) {
      const updatedOrder = {
        id: this.order.id,
        site: this.order.site,
        status: newStatus,
        contragent: {contragentType:"individual"}
      };

      try {
        const response = await fetch(ORDERS_API_BASE + "/orderSto.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            order: updatedOrder,
            edit: true // обязательно, чтобы сервер понял, что это обновление
          })
        });

        const data = await response.json();
        if (!data.success) {
          console.error("Ошибка обновления статуса:", data.message);
          alert("Ошибка при обновлении заказа: " + data.message);
        }
      } catch (error) {
        console.error("Ошибка при обновлении статуса:", error);
        alert("Произошла ошибка при обновлении статуса.");
      }
    }

  }
};
</script>

<style scoped>
.custom-select-wrapper {
  position: relative;
  display: inline-block;
  width: 145px;
}
.custom-select {
 padding: 5px 12px;
    border: 0px solid #dbd1b2;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 0px;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.custom-select .arrow {
  float: right;
  transition: transform 0.3s ease;
}
.custom-select .arrow.open {
  transform: rotate(180deg);
}
.custom-select-options {
  position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    border: 1px solid #ccc;
    max-height: 100%;
    background: #fff;
    z-index: 99999999;
    margin: 0;
    padding: 0;
    list-style: none;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgb(0 0 0 / 15%);
}
.custom-select-options li {
  padding: 8px 8px;
    cursor: pointer;
    line-height: 12px;
    font-size: 12px;
}
.custom-select-options li:hover {
  background: #eee;
}

.arrow svg {
  width: 14px;
  height: 14px;
}

.title_status {
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
